// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Burundi */
const BI = /^(?:(?:29|6[1-9]|7[125-9])\d{6})$/;

export default BI;
